<template>
  <v-container>
    <user-form-modal :editing="editing" :title="'Create User'" @dialog-clicked="editing = false"
    />
    <v-row >
      <v-col cols="12">
        <div class="text-left">
          <h2> Manage Users</h2>
        </div>
      </v-col>
    </v-row>
    <v-row >
      <v-col
          v-for="user in users"
          :key="user.id"
          :lg="4"
          :md="6"
          :sm="12"
          :xl="4" :xs="12"
      >
        <user-card :detailOpen="false" :user="user"/>
      </v-col>
    </v-row>
    <v-row class="py-5 ml-1">
      <v-btn class="ml-2" color="primary" @click="editing = true">Add New User</v-btn>

    </v-row>


  </v-container>
</template>

<script>
import UserCard from '@/components/users/UserCard.vue'
import {mapState} from 'vuex'
import UserFormModal from '@/components/forms/UserFormModal.vue'

export default {
  name: 'ManageUsers',
  components: {
    UserCard,
    UserFormModal
  },
  data() {
    return {
      search: '',
      editing: false
    }
  },
  computed: {
    ...mapState({
      users: state => state.users.users
    }),
  },
  mounted() {
  },
  methods: {}
}
</script>

<style>
</style>
